export function isMykadIdType(selected, options = []) {
  const code =
    selected && typeof selected === "object"
      ? selected.value_code || selected.code || selected.id || selected.value
      : selected;
  const option = options.find((item) => {
    const optionCode =
      item.value_code !== undefined
        ? item.value_code
        : item.id !== undefined
        ? item.id
        : item.value;
    return String(optionCode) === String(code);
  });
  const label = option
    ? option.text || option.name || option.value
    : selected && typeof selected === "object"
    ? selected.text || selected.name || selected.value
    : selected;

  return String(label || "")
    .replace(/[\s_-]/g, "")
    .toUpperCase() === "MYKAD";
}
